import { gsap, Sine } from "gsap";

export default class MorePickupItem {
  constructor() {
    this.contents = document.querySelector('._pickup_item');
    if (!this.contents) {
      return;
    }
    this.more = this.contents.querySelector('._more');
    this.close = this.contents.querySelector('._close');

    this.scrollTop;

    this.setup()
  }

  setup () {
    const carouselEls = document.querySelectorAll('._carouselItem.off');

    this.more.addEventListener('click', (event) => {

      this.contents.classList.add("open");
      this.more.classList.add("off");
      this.close.classList.add("on");

      if (carouselEls) {
        const focusEl = carouselEls[0]?.querySelector('a, button')
        focusEl.focus()
      }

      carouselEls.forEach(el => {
        el.setAttribute('aria-hidden', 'false');
        el.removeAttribute('tabindex');
      });

      this.scrollTop = (document.documentElement || document.body.parentNode || document.body).scrollTop;
    });
    this.close.addEventListener('click', (event) => {

      this.contents.classList.remove("open");
      this.more.classList.remove("off");
      this.close.classList.remove("on");

      gsap.to(document.documentElement, {
        scrollTop: this.scrollTop,
        duration: 0.6,
        ease: Sine.easeInOut
      });

      carouselEls.forEach(el => {
        el.setAttribute('aria-hidden', 'true')
        el.setAttribute('tabindex', '-1')
      })
    });
  }

}
